import { IParamsTable } from '~/interfaces/IParamsTable';
import { authFetch } from '~/services/fetch';
// Work shift interface is imported within IWorkSchedule. No direct usage here.
import IWorkSchedule from '../interfaces/IWorkSchedule';
import { IUpdateProps } from '~/interfaces/IUpdateProps';

export async function getWorkSchedulePrintById(id: IUpdateProps) {
  const response = await authFetch({
    url: `/WorkSchedule-Print/${id}`,
    method: 'GET',
  });
  return response.data;
}

export async function getWorkSchedulePrints({
  filters = [],
  limit = 100000,
  orders = [{ field: 'name', sort: 'asc' }],
  name,
}: IParamsTable & { readonly name?: string; readonly work_hours?: number } = {}) {
  const response = await authFetch({
    url: '/WorkSchedule-Print',
    method: 'POST',
    data: {
      filters,
      orders,
      limit,
      name,
    },
  });
  return response.data;
}

export async function getWorkSchedulesByUser({ userId }: { readonly userId: number }) {
  const response = await authFetch({
    url: '/work-schedule/find-device-crew',
    method: 'POST',
    data: { user_id: userId },
  });

  return response.data as readonly IWorkSchedule[];
}

export async function getWorkSchedulesByDevice({ deviceId }: { readonly deviceId: number }) {
  const response = await authFetch({
    url: '/work-schedule/find-device-crew',
    method: 'POST',
    data: { device_id: deviceId },
  });

  return response.data as readonly IWorkSchedule[];
}